import { Breadcrumb } from "antd";
import React, { JSX } from "react";
import SearchBarWidget from "../../widgets/SearchBarWidget";


const Headline = (
  props: {
    bannerImage: string;
    showSearch?: boolean;
    title?: string;
    children?: JSX.Element;
    breadcrumbs: any[];
  }
) => {
  const { bannerImage, title, children, breadcrumbs } = props;
  return (
    <>
      {(props.showSearch == undefined || props.showSearch && props.showSearch == true) && <SearchBarWidget searchLayout="horizontal" destinationLabel="Series Tour" destinationPlaceholder="Search by Destination"/>}
      <div className="headline">
        <div className="headline_banner" style={{backgroundImage: `url(${bannerImage})`}}></div>
        <div className="headline_header"> 
          { title ? <h1> {title} </h1> : children}
          <Breadcrumb items={breadcrumbs} separator=">"/>
        </div>
      </div>
    </>
  )
}

export default Headline;